export default __webpack_public_path__ + "static/media/pixellab--web-design--01a--600x450.7ee0d19a.jpg";